/**
 * Whitelist of route paths exposed in the client API documentation.
 * Endpoints not included in this list are hidden when `isDetailed` is false and can be accessed through /documentation/detailed..
 *
 * @type {readonly string[]}
 */
const CLIENT_ROUTES = [
    '/getfeasibility',
    '/getfeasibility/references',
    '/getclientsubscriptions',
    '/getmap'
];

/**
 * Filters an OpenAPI/Swagger specification object based on the user's access scope.
 *
 * - If `isDetailed` is `true`, the full, unfiltered specification is returned.
 * - If `isDetailed` is `false`, the specification is filtered to expose only
 *   the endpoints listed in `CLIENT_ROUTES`.
 *
 * @param {Object} originalSpec - The complete OpenAPI spec object.
 * @param {Object} originalSpec.paths - Map of endpoint path templates to operation objects.
 * @param {Array<Object>} [originalSpec.tags] - Global metadata tags used for categorizing endpoints.
 * @param {boolean} isDetailed - Flag indicating whether the client is authorized to view internal endpoints.
 * @returns {Object} A new OpenAPI spec object filtered for client documentation, or the original spec if detailed.
 */
export const filterApiDocs = (originalSpec, isDetailed) => {
    if (isDetailed) {
        return originalSpec;
    }

    const spec = { ...originalSpec, paths: {}, tags: [] };
    const usedTags = new Set();

    Object.keys(originalSpec.paths).forEach((pathKey) => {
        if (CLIENT_ROUTES.includes(pathKey)) {
            spec.paths[pathKey] = originalSpec.paths[pathKey];

            // Track tags used by these specific external paths
            Object.values(spec.paths[pathKey]).forEach((methodDef) => {
                if (methodDef.tags) {
                    methodDef.tags.forEach((tag) => usedTags.add(tag));
                }
            });
        }
    });

    // Filter root tags to prevent empty categories in the Redoc sidebar
    if (originalSpec.tags) {
        spec.tags = originalSpec.tags.filter((tag) => usedTags.has(tag.name));
    }

    return spec;
};